module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrows-h-45e5d375c158b36b5552a3566a30e0be.svg";